var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qrcode"},[_c('qrcode',{attrs:{"value":_vm.value,"size":_vm.size,"level":"H"}}),_vm._v(" "),(!_vm.noLogo)?_c('img',{staticClass:"qrcode-logo",attrs:{"src":_vm.logoPng}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }